<template>
  <div
    v-if="additionalInfo && additionalInfo.length"
    class="additionalInfo">

    <div
      v-for="item in additionalInfo"
      :key="item.id"
      class="formGroup mt30"
      :class="{ isRequired: item.isRequired }">

      <label class="label">
        {{ item.label && item.label[lang] }}
      </label>

      <!-- input -->
      <input
        v-if="item.type === 'input'"
        type="text"
        class="input"
        :value="getInputValue(item.id)"
        @input="setInputValue(item, $event.target.value)" />
      <!-- //input -->

      <!-- radio -->
      <div
        v-else-if="item.type === 'radio'"
        class="optionList">
        <span
          v-for="option in item.options || []"
          :key="option.id"
          class="checkbox">
          <input
            type="radio"
            :name="item.id"
            :id="option.id"
            :value="option.id"
            :checked="isSelected(item.id, option.id)"
            @change="setSingleOption(item, option)" />
            <label :for="option.id">{{ option.label && option.label[lang] }}</label>
        </span>
      </div>
      <!-- //radio -->

      <!-- checkbox -->
      <div
        v-else-if="item.type === 'checkbox'"
        class="optionList">
        <span
          v-for="option in item.options || []"
          :key="option.id"
          class="checkbox">
          <input
            type="checkbox"
            :name="item.id"
            :id="option.id"
            :value="option.id"
            :checked="isSelected(item.id, option.id)"
            @change="toggleOption(item, option)" />
          <label :for="option.id">{{ option.label && option.label[lang] }}</label>
        </span>
      </div>
      <!-- //checkbox -->

      <!-- select -->
      <select
        v-else-if="item.type === 'select'"
        class="input select"
        :value="getSingleOptionId(item.id)"
        @change="setSelectValue(item, $event.target.value)">
        <option value="" disabled>
          {{ locale.select_option || '-' }}
        </option>

        <option
          v-for="option in item.options || []"
          :key="option.id"
          :value="option.id">
          {{ option.label && option.label[lang] }}
        </option>
      </select>
      <!-- //select -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'ReservationFormAdditionalInfo',

  props: [
    'lang',
    'locale',
    'additionalInfo',
    'value'
  ],

  computed: {
    values () {
      return this.value || []
    }
  },

  methods: {
    getValue (id) {
      return this.values.find(item => item.id === id)
    },
    getInputValue (id) {
      const item = this.getValue(id)
      return (item && item.value) || ''
    },
    getSingleOptionId (id) {
      const item = this.getValue(id)
      const value = item && item.value

      return Array.isArray(value) && value.length
        ? value[0].id
        : ''
    },
    isSelected (id, optionId) {
      const item = this.getValue(id)
      const value = item && item.value

      return Array.isArray(value) &&
        value.some(option => option.id === optionId)
    },
    makeValue (item, value) {
      return {
        id: item.id,
        label: item.label,
        type: item.type,
        value
      }
    },
    updateValue (item, value) {
      const values = [...this.values]
      const index = values.findIndex(x => x.id === item.id)
      const next = this.makeValue(item, value)

      if (index >= 0) {
        values.splice(index, 1, next)
      } else {
        values.push(next)
      }

      this.$emit('input', values)
      this.$emit('setAdditionalInfo', values)
    },
    setInputValue (item, value) {
      this.updateValue(item, value)
    },
    setSingleOption (item, option) {
      this.updateValue(item, [{
        id: option.id,
        label: option.label
      }])
    },
    toggleOption (item, option) {
      const current = this.getValue(item.id)
      const values = current && Array.isArray(current.value)
        ? [...current.value]
        : []

      const index = values.findIndex(x => x.id === option.id)

      if (index >= 0) {
        values.splice(index, 1)
      } else {
        values.push({
          id: option.id,
          label: option.label
        })
      }

      this.updateValue(item, values)
    },
    setSelectValue (item, optionId) {
      const option = (item.options || [])
        .find(option => option.id === optionId)

      this.updateValue(
        item,
        option
          ? [{
              id: option.id,
              label: option.label
            }]
          : []
      )
    }
  }
}
</script>